import {Organization} from './organization';
import {MachineModel} from './machine-model';
import {TelemetryData} from './telemetry-data';
import {Subscription} from './subscription';
import {Geocoding} from './geocoding';
import {MachineGroup} from './machine-group';

export class Machine {
  machineUuid: string;
  alias: string;
  description?: string;
  serial: string;
  longitude: number;
  latitude: number;
  deleted: boolean;
  manufacturingDate: string;
  automaticGeoloc: boolean;
  organization: Organization;
  model: MachineModel;
  subscription: Subscription;
  subscriptionHistory: Subscription[];
  telemetryData: TelemetryData;
  geocoding: Geocoding;
  groups?: MachineGroup[];
  simNumber: string;
  tenantUuid?: string;
}
